import { makeStyles } from '@material-ui/core/styles';

const FeaturedPostStyles =
    makeStyles((theme) => ({
        featuredPostContainer: {
            display: "flex",
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.secondary,
            marginBottom: theme.spacing(8),

            [theme.breakpoints.down("md")]: {
                display: "inline-block",
            },

            "&:nth-child(even) > $featuredPostImgContainerStyles": {
                order: 2,
            }
        },
        featuredPostSummaryContainer: {
            padding: "60px 50px 80px",
            width: "66%",
            position: "relative",
        },
        featuredPostImgContainerStyles: {
            width: "34%",
            verticalAlign: "middle", 
            display: "flex",
        },
        title: {
            margin: `${theme.spacing(2)}px 0`,
        },
        content: {
            marginBottom: theme.spacing(4),
        },
        link: {
            position: "absolute",
            bottom: theme.spacing(4),
            left: theme.spacing(6),
        }
    }));

export default FeaturedPostStyles;